import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-show-qr',
  templateUrl: './show-qr.component.html',
  styleUrls: ['./show-qr.component.scss']
})
export class ShowQrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
